import { render } from "./SlotWithValue.vue?vue&type=template&id=46f25357"
import script from "./SlotWithValue.vue?vue&type=script&lang=js"
export * from "./SlotWithValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__